<div class="bg-white px-4 py-4 rounded-5">
  <div class="px-2 py-3">
    <ng-container *ngIf="step === 'INFO'">
      <div class="mb-3 text-center">
        <img src="/assets/images/totp-enable.svg" class="main-svg" />
      </div>

      <div class="text-center mb-3">
        <span class="step-indicator">Step 1 of 3</span>
      </div>
      <div class="text-center mb-3">
        <h2 class="mb-1">Protect your account</h2>
        <p>We require an extra layer of security for your account</p>
      </div>

      <div class="d-flex align-items-center gap-3 justify-content-center mx-auto" style="gap: 1rem; max-width: 370px;">
        <svg width="45" height="55" style="min-width: 45px;" viewBox="0 0 45 55" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="45" height="55" rx="8" fill="#E8FDFF"/>
          <path d="M22.4982 37.6901H22.5152M14.0062 10.5156H30.9902C32.8662 10.5156 34.387 12.0364 34.387 13.9124V41.0869C34.387 42.9629 32.8662 44.4837 30.9902 44.4837H14.0062C12.1302 44.4837 10.6094 42.9629 10.6094 41.0869V13.9124C10.6094 12.0364 12.1302 10.5156 14.0062 10.5156Z" stroke="#2672CA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <div>
          <h3>Two-step verification</h3>
          <p class="fs-14 opacity-70p">Each time you sign in, you'll enter a code from your authenticator app along with your password.</p>
        </div>
      </div>

      <div class="or-divider my-4"><div></div></div>

      <div>
        <h3 class="pb-2">What you'll need:</h3>
        <ul class="opacity-70p mb-2">
          <li>Your smartphone with Google Authenticator installed</li>
          <li>About a minutes to complete setup</li>
        </ul>
      </div>

      <div class="pt-3">
        <button
          class="btn btn-success w-100"
          (click)="getQRCode()"
          [disabled]="working"
        >
          Setup Now
          <ng-container *ngIf="!working"><iconify name="majesticons:chevron-right"></iconify></ng-container>
          <ng-container *ngIf="working"><loading-icon></loading-icon></ng-container>
        </button>

        <div class="d-flex align-items-center justify-content-center pt-3 text-secondary gap-1 line-height-140p fs-15">
          Password reset required?
          <button
            (click)="goToPasswordReset();"
            class="btn d-inline-flex text-primary px-0 py-0 fs-16" style="font-size: inherit;">Reset your Password →</button>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="step === 'QR_SCAN'">
      <div class="text-center mb-3">
        <span class="step-indicator">Step 2 of 3</span>
      </div>

      <div class="text-center mb-3">
        <h2 class="mb-1" style="color: #1A1A1A;">Scan the QR code</h2>
        <p>Use Google Authenticator on your phone</p>
      </div>

      <div class="mb-3 text-center">
        <img [src]="qrCode" class="qr-code" />
      </div>

      <ul class="instructions-list">
        <li class="instruction">
          <div class="icon-wrapper"><iconify name="lucide:smartphone"></iconify></div>
          <p>Open Google Authenticator on your phone</p>
        </li>
        <li class="instruction">
          <div class="icon-wrapper"><iconify name="lucide:plus"></iconify></div>
          <p>Tap the + icon to add a new account</p>
        </li>
        <li class="instruction">
          <div class="icon-wrapper"><iconify name="lucide:qr-code"></iconify></div>
          <p>Scan this QR code</p>
        </li>
      </ul>

      <div class="or-divider my-3">
        <div></div>
        OR
        <div></div>
      </div>

      <div class="px-3 py-3" style="background-color: #F9FBFF; border: 1px solid #EDF1FF;">
        <div
          (click)="toggleSecretKey();"
          role="button"
          class="d-flex align-items-center justify-content-center gap-2 pointer" style="color: #2672CA;">
          <iconify class="text-dark" name="lucide:key"></iconify>
          <span><span class="text-dark">Can’t scan the QR code?</span> &nbsp;<span>Setup Manually</span></span>
          <span class="d-inline-block px-1"><iconify name="lucide:chevron-down"></iconify></span>
        </div>

        <div class="pt-3" *ngIf="showSecretKey">
          <div class="fs-14 opacity-75 pb-1">Enter this setup key manually:</div>
          <div class="input-group">
            <div class="form-control border-end-0 bg-white" style="word-break: break-all;">{{secretKey}}</div>
            <span
              (click)="copySecretKey();"
              class="input-group-text border-start-0 text-primary bg-white fs-20 pointer"><iconify name="lucide:copy"></iconify></span>
          </div>
        </div>
      </div>

      <div class="pt-3">
        <button
          class="btn btn-success w-100"
          (click)="step = 'OTP'"
          [disabled]="working"
        >
          Continue
          <ng-container *ngIf="!working"><iconify name="majesticons:chevron-right"></iconify></ng-container>
          <ng-container *ngIf="working"><loading-icon></loading-icon></ng-container>
        </button>
      </div>
    </ng-container>

    <ng-container *ngIf="step === 'OTP'">
      <div class="text-center mb-3">
        <span class="step-indicator">Step 3 of 3</span>
      </div>

      <div class="text-center mb-3">
        <h2 class="mb-1" style="color: #1A1A1A;">Verify your setup</h2>
        <p>Enter the 6-digit code from your authenticator app</p>
      </div>

      <div class="mb-3 text-center">
        <app-otp-input
          (onValueChange)="otp = $event;"
          (onVerifyOtp)="verifyOtp();"
        ></app-otp-input>

        <div class="pt-1 fst-italic opacity-70p">
          The code expires every 60 seconds
        </div>
      </div>

      <div>
        <button
          class="btn btn-success w-100"
          (click)="verifyOtp()"
          [disabled]="working"
        >
          Verify Code
          <ng-container *ngIf="!working"><iconify name="majesticons:chevron-right"></iconify></ng-container>
          <ng-container *ngIf="working"><loading-icon></loading-icon></ng-container>
        </button>
      </div>
    </ng-container>

    <ng-container *ngIf="step === 'SUCCESS'">
      <div class="mb-3 text-center">
        <svg width="130" height="130" viewBox="0 0 159 159" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="79.3984" cy="79.3984" r="79.3984" fill="#EAFFE8"/>
          <circle cx="79.4022" cy="79.4022" r="75.7381" fill="#DBFFD8"/>
          <circle cx="79.3979" cy="79.3979" r="70.2729" fill="#BEFFB9"/>
          <circle cx="79.4065" cy="79.3908" r="64.508" fill="white"/>
          <path d="M70.3765 109.066L115.856 63.5874L106.824 54.5561L70.3765 91.0038L51.9913 72.6187L42.96 81.65L70.3765 109.066ZM79.4078 143.902C70.484 143.902 62.0978 142.207 54.2491 138.818C46.4005 135.429 39.5733 130.834 33.7674 125.033C27.9616 119.227 23.3664 112.399 19.9818 104.551C16.5972 96.7022 14.9027 88.316 14.8984 79.3922C14.8984 70.4684 16.5929 62.0822 19.9818 54.2335C23.3707 46.3849 27.9659 39.5576 33.7674 33.7518C39.5733 27.946 46.4005 23.3507 54.2491 19.9661C62.0978 16.5816 70.484 14.8871 79.4078 14.8828C88.3316 14.8828 96.7178 16.5773 104.566 19.9661C112.415 23.355 119.242 27.9503 125.048 33.7518C130.854 39.5576 135.451 46.3849 138.84 54.2335C142.229 62.0822 143.921 70.4684 143.917 79.3922C143.917 88.316 142.223 96.7022 138.834 104.551C135.445 112.399 130.85 119.227 125.048 125.033C119.242 130.838 112.415 135.436 104.566 138.825C96.7178 142.214 88.3316 143.906 79.4078 143.902Z" fill="#52BA4A"/>
        </svg>

      </div>
      <div class="text-center mb-3">
        <h2 class="mb-1 fs-20 text-dark">Your account is now protected</h2>
        <p>Two-step verification is active</p>
      </div>

      <div class="what-next rounded-4 px-3 py-4">
        <h3 class="mb-3">What happens next:</h3>
        <ul class="instructions-list gap-3">
          <li class="instruction">
            <div class="icon-wrapper"><iconify name="lucide:lock"></iconify></div>
            <div class="fs-14">
              <p class="text-dark fw-semibold mb-0">Every sign-in requires your password</p>
              <p class="mb-0">Your password is still your first line of defense</p>
            </div>
          </li>
          <li class="instruction">
            <div class="icon-wrapper" style="background-color: #D4FDE7; color: #00A63D;">
              <iconify name="lucide:shield"></iconify>
            </div>
            <div class="fs-14">
              <p class="text-dark fw-semibold mb-0">Plus a code from your authenticator app</p>
              <p class="mb-0">This adds an extra layer of security</p>
            </div>
          </li>
        </ul>
      </div>

      <div class="border rounded-3 px-3 py-3 d-flex align-items-center flex-wrap gap-3 mt-3 mb-2">
        <div class="name-avatar">{{userInfo?.firstname?.[0] || ''}}</div>
        <div class="flex-grow-1 mx-3">
          <p class="mb-0">{{(userInfo?.firstname + ' ' + userInfo?.surname) | titlecase}}</p>
          <p class="mb-0">{{getRedactedEmail()}}</p>
        </div>
        <div>
          <span class="badge bg-success-subtle text-success d-flex align-items-center gap-1 py-2">
            <iconify name="lucide:check"></iconify>
            Protected
          </span>
        </div>
      </div>

      <div class="pt-3">
        <button
          class="btn btn-success w-100"
          (click)="proceed()"
          [disabled]="working"
        >
          Continue to Dashboard
          <ng-container *ngIf="!working"><iconify name="majesticons:chevron-right"></iconify></ng-container>
          <ng-container *ngIf="working"><loading-icon></loading-icon></ng-container>
        </button>
      </div>
    </ng-container>
  </div>
</div>
